import { FRONT_WORD, BACK_WORD, FRONT_NOTE, BACK_NOTE, STATUS_DELETED, STATUS_HIDDEN, STATUS_NONE } from './Card';

const makeUid = () => Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);

export const findIndexOfItemByMatchingProp = (prop) => (arr) => (value) => {
    return arr.reduce((match, item, index) => {
        if (match < 0 && value === item[prop]) return index;
        return match;
    }, -1);
};

export const duplicateData = source => {
    let { data } = source;
    data = data.map(values => values.map(value => value));
    return Object.assign({}, source, { data });
};

export const compareFlatDecks = (deckA, deckB) => {
    return deckA.name === deckB.name &&
        deckA.description === deckB.description &&
        deckA.isPublic === deckB.isPublic &&
        deckA.targetLanguage === deckB.targetLanguage &&
        deckA.data.every((values, rowIndex) =>
            values.every((value, valueIndex) =>
                valueIndex === 0 || value === deckB.data[rowIndex][valueIndex]));
};
export const compareArrayValues = (arr1, arr2) => {
    if (!arr1 || arr1.constructor !== Array || !arr2 || arr2.constructor !== Array) throw new TypeError('compareArrayValues requires two arrays of scalars');
    return arr1.length === arr2.length && arr1.every((item, index) => item === arr2[index]);
};
export const compareCards = function (cardA, cardB) {
    if (!cardA || !cardB) return false;

    return cardA.state === cardB.state && compareArrayValues(cardA.values, cardB.values);
};
export const makeEmptyRow = () => [ makeUid(), 0, null, '', '', '', ''];
export const makeRowHavingValues = values => [].concat([ makeUid(), 0, null], values, ['', '', '', '']).slice(0, 7);
export const makeEmptyCard = () => ({ lastSeen: null, timesSeen: 0, state: STATUS_NONE, values: ['', '', '', ''] });
export const makeEmptyDeck = () => ({ id: '', name: '', description: '', baseLanguage: 'en', cards: [], cardCount: 0, targetLanguage: '' });
export const buildReordererByCustomOrder = (customOrder) => (values) => customOrder.map(visibleIndex => values[visibleIndex] || '');
const visibleOrder = [FRONT_WORD, FRONT_NOTE, BACK_WORD, BACK_NOTE];
export const reorderRowValuesByVisibleOrder = buildReordererByCustomOrder(visibleOrder);

export const flattenDeck = deck => {
    let { name, description, isPublic, cards, targetLanguage } = deck;

    let data = cards.map(card => {
        let { state, values } = card;
        let id = makeUid();
        values = reorderRowValuesByVisibleOrder(values);

        return [
            id,
            state,
            card,
            ...values
        ];
    });

    return {
        data: [...data, makeEmptyRow()],
        description: description || '',
        isPublic: isPublic || false,
        name: name || '',
        targetLanguage: targetLanguage || ''
    };
};
export const rebuildCardFromRow = row => {
    let [ , state, card, ...values ] = row;
    values = reorderRowValuesByVisibleOrder(values);

    return Object.assign({}, card || makeEmptyCard(), { state, values, lastSeen: 0, timesSeen: 0 });
};
export const trimArrayRight = arr => {
    let lastPopulatedIndex = Math.max(...arr.map((item, index) => item !== undefined && item !== null && item !== '' ? index : -1));
    return arr.slice(0, lastPopulatedIndex + 1);
};
export const dehydrateCard = card => Object.assign({}, card, { values: trimArrayRight(card.values) });
export const purgeDeadCards = (cards) => cards.filter(card => card.state < STATUS_HIDDEN);
export const dataHasValues = ([,,, ...values]) => !values.every(value => !value);
export const dataIsHiddenOrDeleted = ([,state]) => state !== STATUS_HIDDEN && state !== STATUS_DELETED;
export const debounce = (fn, delay) => {
    let currentTimeout = null;

    return (...args) => new Promise(resolve => {
        clearTimeout(currentTimeout);
        currentTimeout = setTimeout(() => resolve(fn(...args)), delay);
    });
};
export const cache = (fn, maxLength = 10) => {
    let cache = [];

    return (...args) => {
        let existing = cache.find(item => item.args.every((arg, index) => arg === args[index]));
        if (existing) return Promise.resolve(existing.results);

        return Promise.resolve()
        .then(() => fn(...args))
        .then(results => {
            cache = [...cache.slice(1 - maxLength), {args, results}];
            return results;
        });
    };
};
const alphas = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
export const toBase26Alpha = number => {
    let result = [];

    let n = Math.abs(Math.round(number));

    while (n >= 0) {
        result.unshift(alphas[n % 26]);
        n = Math.floor((n - 26) / 26);
    }

    return result.join('');
};
export const normalizeJaggedDataTable = rows => {
    const emptyCells = '                         '.split(' ');
    const lastRowIndex = rows.reduce((currentMax, row) => {
        const lastPopulatedCell = row.reduce((max, cell, index) => {
            if (cell) return Math.max(max, index);
            return max;
        }, currentMax);

        return Math.max(lastPopulatedCell, currentMax);
    }, -1);

    if (lastRowIndex === -1) return [];

    return rows
        .map(row => row.map(cell => cell ? cell : '')
            .concat(emptyCells)
            .slice(0, lastRowIndex + 1)
        );
};

export const transpose = m => m[0].map((x,i) => m.map(x => x[i]));


// WEBPACK FOOTER //
// ./src/services/Utils.js